/**
 * AWS Service Configuration
 * Single active pool: ap-south-2_Qd3Crff1P (akmo-books-web-client)
 * Last updated: 2026-05-12 - unified all auth to single ap-south-2 pool
 */

const awsConfig = {
    region: 'ap-south-2',

    // API Gateway
    apiGateway: {
        URL: 'https://55d7t6ih0l.execute-api.ap-south-2.amazonaws.com/prod/',
    },

    // Cognito (Authentication) - primary pool with all business accounts
    cognito: {
        USER_POOL_ID: 'ap-south-2_Qd3Crff1P',
        APP_CLIENT_ID: '219hmn99gdmpq8sq9kk7lbqv4j',
        IDENTITY_POOL_ID: 'ap-south-2:9cf90d7c-9854-4da2-9fa2-32691050fcfa',
    },

    // S3 (File Storage)
    s3: {
        BUCKET: 'akmo-books-storage-046801217028-ap-south-2',
    },

    // DynamoDB (Table Names)
    dynamodb: {
        TABLES: {
            USERS: 'akmo-books-users',
            INVOICES: 'akmo-books-invoices',
            CLIENTS: 'akmo-books-clients',
            INVENTORY: 'akmo-books-inventory',
            TRANSACTIONS: 'akmo-books-transactions',
            AUDIT_LOGS: 'akmo-books-audit-logs',
        },
    },
};

export default awsConfig;

